import React, { memo, useRef, useEffect } from 'react';
import classnames from 'classnames';
import '@gp/components/AutoTextareaNew/index.scss';

interface IAutoTextareaProps extends IBaseProps {
  // 最小高度
  minHeight?: number;
  // 最大输入长度
  maxLength?: number;
  // 是否显示字符数统计
  showCount?: boolean;
  // 占位文案
  placeholder?: string;
  // 是否禁用
  disabled?: boolean;
  // 是否只读
  readonly?: boolean;
  // value值
  value?: string;
  // change回调
  onChange?: (value: string, e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  // 强制设置textarea的高度
  forceHeight?: number;
  // 获取textarea被设置的高度
  getTextAreaHeight?: (value: number) => void;
}

const AutoTextarea: React.FC<IAutoTextareaProps> = (props) => {
  const {
    minHeight,
    maxLength,
    showCount,
    placeholder = 'Please enter information',
    disabled,
    readonly,
    value,
    onChange,
    forceHeight,
    getTextAreaHeight,
    style,
    showPrefixText = false,
    isDisabledEnter = false,
    prefixText = '',
    className,
    ...remains
  } = props;

  const textarea = useRef<HTMLTextAreaElement>(null);

  const updateHeight = () => {
    if (!textarea.current) {
      getTextAreaHeight?.(0);
      return;
    }
    textarea.current.style.height = minHeight ? `${minHeight}px` : 'auto';
    const h = textarea.current.scrollHeight + 2;
    textarea.current.style.height = `${h}px`;
    getTextAreaHeight?.(h);
  };

  const handleChange: React.ChangeEventHandler<HTMLTextAreaElement> = (e) => {
    onChange?.(e?.target?.value || '', e);
  };

  useEffect(() => {
    updateHeight();
  }, [value]);

  // 强制设置的高度
  useEffect(() => {
    if (forceHeight && textarea.current) {
      textarea.current.style.height = `${forceHeight}px`;
    }
  }, [forceHeight]);

  const handleKeyDown = (e: any) => {
    if (e.key === 'Enter' && isDisabledEnter) {
      e.preventDefault(); // 阻止默认的回车换行行为
    }
  };

  return (
    <div
      style={style}
      className={classnames('gp-common-auto-textarea-comp gp-inital-list-style', className, { disabled })}
    >
      {showPrefixText && <div className="dbg-auto-text-area-new-prefix-text">{prefixText}</div>}
      <textarea
        ref={textarea}
        {...remains}
        className={classnames('auto-textarea', { 'has-footer': showCount })}
        onKeyDown={handleKeyDown}
        style={{ height: minHeight ?? 'auto' }}
        placeholder={placeholder}
        rows={1}
        maxLength={maxLength}
        disabled={disabled}
        readOnly={readonly}
        value={value}
        onChange={handleChange}
      />
      {showCount && (
        <div className="gp-common-auto-textarea-footer">
          <span>{value?.length}</span>
          {maxLength && (
            <>
              <span>/</span>
              <span>{maxLength}</span>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(AutoTextarea);
